// third-party
import { FormattedMessage } from 'react-intl';

// assets
import MedicineBoxOutlined from '@ant-design/icons/MedicineBoxOutlined';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';

// type

// icons
const icons = { GroupAddOutlinedIcon, MedicineBoxOutlined, AssessmentOutlinedIcon, ChecklistOutlinedIcon, HistoryOutlinedIcon };

// ==============================|| MENU ITEMS - ADMIN ||============================== //

const admin = {
  id: 'admin',
  title: <FormattedMessage id="Admin" />,
  icon: icons.GroupAddOutlinedIcon,
  type: 'group',
  children: [

    /** !!! Please do not add sub-items that are already listed under other menu items. 
     *  This causes duplicate items to be displayed on the navbar.
    **/

    // Uncomment the following code to add a dashboard link to the admin menu
    {
      id: 'dashboard',
      key: 'dashboard',
      title: <FormattedMessage id="Dashboard" />,
      type: 'item',
      url: '/admin/dashboard',
      icon: icons.AssessmentOutlinedIcon
    }, 
    {
      id: 'super_user_preferences',
      key: 'super_user_preferences',
      title: <FormattedMessage id="Superuser Preferences" />,
      type: 'item',
      url: '/admin/super-user-preferences',
      icon: icons.ChecklistOutlinedIcon
    }, 
    {
      id: 'export_data',
      key: 'export_data',
      title: <FormattedMessage id="Export Data" />,
      type: 'item',
      url: '/admin/export-data',
      icon: icons.MedicineBoxOutlined
    },
    {
      id: 'audit_logs',
      key: 'audit_logs',
      title: <FormattedMessage id="Audit Logs" />,
      type: 'item',
      url: '/admin/audit-logs',
      icon: icons.HistoryOutlinedIcon
    },
  ]
};

export default admin;
